import styled, {css} from "styled-components";

export interface ICrossBrandItemProps {
  customProps?: {
    poker?: boolean;
    sport?: boolean;
    casino?: boolean;
  }
}

export const CrossBrandItemDefaultBox = styled.div<ICrossBrandItemProps>`

  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  margin: 0 0.5rem;
  padding: 0;
  font-family: ${props => props.theme.font.family.black};
  font-size: 0.9rem;
  line-height: 1;
  text-transform: uppercase;

  &:hover {
    cursor: pointer;
  }

  ${props => props.customProps && props.customProps.poker && css`
    color: #007cf7;
  `}

  ${props => props.customProps && props.customProps.sport && css`
    color: #fa6200;
  `}

  ${props => props.customProps && props.customProps.casino && css`
    color: #7dfb02;
  `}
`;
